// client/src/components/templates/TemplateRow.js
import React from 'react';
import { MoreVertical, Star } from 'lucide-react';
import Switch from 'react-switch';

const TemplateRow = ({
    template,
    tipo,
    onOpenActions,
    onPreferenceChange,
    isUpdatingPreference,
    isMatrizAdmin
}) => {
    const isGlobalPadrao = template.isPadrao && !template.account && !template.franquia;

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        // Formata para DD/MM/AAAA, HH:mm:ss
        return new Date(dateString).toLocaleString('pt-BR');
    };

    return (
        <tr 
            className={`transition-colors duration-150 ${isGlobalPadrao ? 'bg-blue-50 hover:bg-blue-100' : 'hover:bg-gray-50'}`} 
            // A ação de clique na linha inteira para preview foi removida para evitar cliques acidentais
            // Apenas o botão de olho agora aciona o preview
        >
            {/* Coluna NOME */}
            <td>
                <div className="flex items-center gap-2">
                    {isGlobalPadrao && <Star size={16} className="text-yellow-500 flex-shrink-0" title="Template Padrão Global" />}
                    <span className="font-medium text-gray-900">{template.nome || '-'}</span>
                </div>
                {template.isOverridden && <span className="text-xs text-blue-600 ml-6">(Visibilidade personalizada)</span>}
            </td>
            
            {/* Coluna CANAL (apenas para mensagens) */}
            {tipo === 'mensagem' && (
                <td>
                    <span className="badge-blue">{template.canal || '-'}</span>
                </td>
            )}
            
            {/* Coluna DESCRIÇÃO */}
            <td>
                <div className="text-sm text-gray-500">{template.descricao || '-'}</div>
            </td>
            
            {/* Coluna MODIFICADO EM */}
            <td>
                <div className="text-sm text-gray-500">
                    {formatDate(template.updatedAt)}
                </div>
            </td>
            
            {/* ✅ CORREÇÃO: Coluna VISIBILIDADE / STATUS */}
            <td className="text-center">
                {isGlobalPadrao && !isMatrizAdmin ? (
                    <div title={template.ativo ? "Desativar para sua organização" : "Ativar para sua organização"}>
                        <Switch
                            onChange={(isChecked) => onPreferenceChange(template, isChecked)}
                            checked={template.ativo}
                            disabled={isUpdatingPreference}
                            onColor="#2563eb"
                            offColor="#cccccc"
                            height={20}
                            width={40}
                            handleDiameter={18}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            aria-label="Ativar ou desativar template para sua organização"
                        />
                    </div>
                ) : (
                    <span className={`badge ${template.ativo ? 'badge-green' : 'badge-red'}`}>
                        {template.ativo ? 'Ativo' : 'Inativo'}
                    </span>
                )}
            </td>

            {/* Coluna AÇÕES */}
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onOpenActions(template); }}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default TemplateRow;